<template>
	<div style="display: flex; flex-direction: column">
		<v-tabs v-model="tab" background-color="rgb(0, 51, 102)" dark>
			<v-tab v-for="(type, index) in typeExprience" :key="index" @click="openTab(type)">{{ type }}</v-tab>
		</v-tabs>

		<v-tabs-items v-model="tab">
			<v-tab-item key="Exhibition">
				<v-row class="fill-height">
					<v-col>
						<v-sheet height="64">
							<v-toolbar flat>
								<v-btn class="mr-4" color="primary" @click="setExhibitionToday"> Today </v-btn>
								<v-btn fab text small color="grey darken-2" @click="exhibitionPrev">
									<v-icon small> mdi-chevron-left </v-icon>
								</v-btn>
								<v-btn fab text small color="grey darken-2" @click="exhibitionNext">
									<v-icon small> mdi-chevron-right </v-icon>
								</v-btn>
								<v-toolbar-title v-if="$refs.calendarExhibition">
									{{ $refs.calendarExhibition.title }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-autocomplete
									v-model="exhibitionTimezone"
									:rules="[(v) => !!v || 'Time Zone is required']"
									:items="timeZoneList"
									label="Time Zone"
									prepend-icon="mdi-map-clock"
									dense
									style="margin-top: 20px"
								></v-autocomplete>
								<v-btn class="mr-4" color="primary" style="margin-left: 10px" @click="exhibitionUpdateRange"> show </v-btn>
							</v-toolbar>
						</v-sheet>
						<br />
						<v-sheet min-height="100px">
							<v-calendar
								:event-more="false"
								ref="calendarExhibition"
								v-model="exhibitionFocus"
								color="primary"
								:events="exhibitionEventList"
								:event-color="getEventColor"
								@click:event="exhibitionShowEvent"
								@change="exhibitionUpdateRange"
							></v-calendar>
							<v-menu
								v-model="exhibitionSelectedOpen"
								:close-on-content-click="false"
								:activator="exhibitionSelectedElement"
								offset-y
								min-width="340"
							>
								<v-card color="grey lighten-4" width="340" class="mb-5" flat>
									<v-toolbar :color="exhibitionSelectedEvent.color" dark>
										<v-toolbar-title v-html="exhibitionSelectedEvent.name"></v-toolbar-title>
									</v-toolbar>
									<v-img
										style="background-color: rgba(0, 0, 0, 0.05)"
										aspect-ratio="1.7"
										contain
										:src="$root.asset(exhibitionSelectedEvent.logo)"
										height="200px"
									></v-img>
									<v-card-subtitle>
										{{ exhibitionSelectedEvent.details }}
									</v-card-subtitle>
									<v-card-actions>
										<v-btn text color="secondary" @click="exhibitionSelectedOpen = false"> Cancel </v-btn>
									</v-card-actions>
								</v-card>
							</v-menu>
						</v-sheet>
					</v-col>
				</v-row>
			</v-tab-item>

			<v-tab-item key="Clinic">
				<v-row class="fill-height">
					<v-col>
						<v-sheet height="64">
							<v-toolbar flat>
								<v-btn class="mr-4" color="primary" @click="setClinicToday"> Today </v-btn>
								<v-btn fab text small color="grey darken-2" @click="clinicPrev">
									<v-icon small> mdi-chevron-left </v-icon>
								</v-btn>
								<v-btn fab text small color="grey darken-2" @click="clinicNext">
									<v-icon small> mdi-chevron-right </v-icon>
								</v-btn>
								<v-toolbar-title v-if="$refs.calendarClinic">
									{{ $refs.calendarClinic.title }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-autocomplete
									v-model="clinicTimezone"
									:rules="[(v) => !!v || 'Time Zone is required']"
									:items="timeZoneList"
									label="Time Zone"
									prepend-icon="mdi-map-clock"
									dense
									style="margin-top: 20px"
								></v-autocomplete>
								<v-btn class="mr-4" color="primary" style="margin-left: 10px" @click="clinicUpdateRange"> show </v-btn>
							</v-toolbar>
						</v-sheet>
						<br />
						<v-sheet min-height="100px">
							<v-calendar
								:event-more="false"
								ref="calendarClinic"
								v-model="clinicFocus"
								color="primary"
								:events="clinicEventList"
								:event-color="getEventColor"
								@click:event="clinicShowEvent"
								@change="clinicUpdateRange"
							></v-calendar>
							<v-menu
								v-model="clinicSelectedOpen"
								:close-on-content-click="false"
								:activator="clinicSelectedElement"
								offset-y
								min-width="340"
							>
								<v-card color="grey lighten-4" width="340" class="mb-5" flat>
									<v-toolbar :color="clinicSelectedEvent.color" dark>
										<v-toolbar-title v-html="clinicSelectedEvent.name"></v-toolbar-title>
									</v-toolbar>
									<v-img
										style="background-color: rgba(0, 0, 0, 0.05)"
										aspect-ratio="1.7"
										contain
										:src="$root.asset(clinicSelectedEvent.logo)"
										height="200px"
									></v-img>
									<v-card-subtitle>
										{{ clinicSelectedEvent.details }}
									</v-card-subtitle>
									<v-card-actions>
										<v-btn text color="secondary" @click="clinicSelectedOpen = false"> Cancel </v-btn>
									</v-card-actions>
								</v-card>
							</v-menu>
						</v-sheet>
					</v-col>
				</v-row>

				<br />
				<v-row>
					<v-col cols="12">
						<h2>Ongoing Clinic</h2>
						<br />
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" style="width:100px">No</th>
										<th class="text-left">Name</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in clinicOngoingList" :key="index">
										<td>{{ index+1 }}</td>
										<td>{{ item.name }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>
        
<script>
import axios from "axios";

export default {
	data() {
		return {
			exhibitionFocus: "",
			exhibitionSelectedEvent: {},
			exhibitionSelectedElement: null,
			exhibitionSelectedOpen: false,
			exhibitionEventList: [],
			exhibitionTimezone: "Europe/London",
			exhibitionStart: null,
			exhibitionEnd: null,
			clinicFocus: "",
			clinicSelectedEvent: {},
			clinicSelectedElement: null,
			clinicSelectedOpen: false,
			clinicEventList: [],
			clinicTimezone: "Europe/London",
			clinicStart: null,
			clinicEnd: null,
			clinicOngoingList: [],
			colorList: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1", "red", "teal", "light-blue darken-4"],
			timeZoneList: [],
			typeExprience: ["Exhibition", "Clinic"],
			tab: "Exhibition"
		};
	},
	mounted() {
		this.listTimeZone();
	},
	methods: {
		getEventColor(event) {
			return event.color;
		},
		// methods Exhibition
		setExhibitionToday() {
			this.exhibitionFocus = "";
		},
		exhibitionPrev() {
			this.$refs.calendarExhibition.prev();
		},
		exhibitionNext() {
			this.$refs.calendarExhibition.next();
		},
		exhibitionShowEvent({ nativeEvent, event }) {
			const open = () => {
				this.exhibitionSelectedEvent = event;
				this.exhibitionSelectedElement = nativeEvent.target;
				setTimeout(() => {
					this.exhibitionSelectedOpen = true;
				}, 10);
			};

			if (this.exhibitionSelectedOpen) {
				this.exhibitionSelectedOpen = false;
				setTimeout(open, 10);
			} else {
				open();
			}

			nativeEvent.stopPropagation();
		},
		exhibitionUpdateRange({ start, end }) {
			if (start) {
				this.exhibitionStart = start;
			}
			if (end) {
				this.exhibitionEnd = end;
			}
			axios
				.post("/system/experience/globalCalendar/list", {
					startDate: this.exhibitionStart.date,
					endDate: this.exhibitionEnd.date,
					timezone: this.exhibitionTimezone,
					type: "Exhibition"
				})
				.then((response) => {
					let listEvent = response.data.data;
					console.log(response.data)
					const eventList = [];
					for (let i = 0; i < listEvent.length; i++) {
						eventList.push({
							id: listEvent[i].id,
							name: listEvent[i].name + " (" + listEvent[i].timeZone + ")",
							start: this.parseDate(listEvent[i].startDate),
							end: this.parseDate(listEvent[i].endDate),
							color: this.colorList[i % 10],
							timed: true,
							logo: listEvent[i].logo,
							details: listEvent[i].transitMap.startDateText + " - " + listEvent[i].transitMap.endDateText
						});
					}
					this.exhibitionEventList = eventList;
				});
		},

		// Methods clinic
		setClinicToday() {
			this.clinicFocus = "";
		},
		clinicPrev() {
			this.$refs.calendarClinic.prev();
		},
		clinicNext() {
			this.$refs.calendarClinic.next();
		},
		clinicShowEvent({ nativeEvent, event }) {
			const open = () => {
				this.clinicSelectedEvent = event;
				this.clinicSelectedElement = nativeEvent.target;
				setTimeout(() => {
					this.clinicSelectedOpen = true;
				}, 10);
			};

			if (this.clinicSelectedOpen) {
				this.clinicSelectedOpen = false;
				setTimeout(open, 10);
			} else {
				open();
			}

			nativeEvent.stopPropagation();
		},
		clinicUpdateRange({ start, end }) {
			if (start) {
				this.clinicStart = start;
			}
			if (end) {
				this.clinicEnd = end;
			}
			axios
				.post("/system/experience/globalCalendar/list", {
					startDate: this.clinicStart.date,
					endDate: this.clinicEnd.date,
					timezone: this.clinicTimezone,
					type: "Clinic"
				})
				.then((response) => {
					let listEvent = response.data.data;
					const eventList = [];
					for (let i = 0; i < listEvent.length; i++) {
						eventList.push({
							id: listEvent[i].id,
							name: listEvent[i].name + " (" + listEvent[i].timeZone + ")",
							start: this.parseDate(listEvent[i].startDate),
							end: this.parseDate(listEvent[i].endDate),
							color: this.colorList[i % 10],
							timed: true,
							logo: listEvent[i].logo,
							details: listEvent[i].transitMap.startDateText + " - " + listEvent[i].transitMap.endDateText
						});
					}
					this.clinicEventList = eventList;
				});
		},
		listClinicOngoing() {
			axios.post("/system/experience/clinic/ongoing/list", {}).then((response) => {
				this.clinicOngoingList = response.data;
			});
		},

		parseDate(datetime) {
			let minute = datetime.time.hour == 0 && datetime.time.minute == 0 ? datetime.time.minute + 1 : datetime.time.minute;
			return new Date(datetime.date.year, datetime.date.month - 1, datetime.date.day, datetime.time.hour, minute, datetime.time.second);
		},
		listTimeZone() {
			axios
				.get("/system/enumeration/timezone/list")
				.then((response) => {
					this.timeZoneList = response.data;
				})
				.catch(() => {});
		},
		openTab(type) {
			if (type == 'Clinic') {
				this.listClinicOngoing();
			}
		}
	}
};
</script>